var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.customer
    ? _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c("account", {
            attrs: { account: _vm.customer },
            on: {
              refresh: function($event) {
                return _vm.getCustomer()
              }
            }
          }),
          _vm._v(" "),
          _c("addresses", { attrs: { accountable: _vm.customer.accountable } }),
          _vm._v(" "),
          _c("orders-history", {
            attrs: {
              user: {
                type: _vm.customer.accountable.type,
                id: _vm.customer.accountable.id
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bf07e36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bf07e36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customers/Legals/Edit.vue
// module id = null
// module chunks = 